import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from "../shared";
import {GlcodeContainerModel} from "../../../../../models/aggregates/payment-configuration";


@Injectable({
  providedIn: 'root'
})
export class GlcodeService extends BaseApiTemplateService<GlcodeContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'glcode';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'glcode';
    this.httpClient = http;
  }
}
